module.exports = __webpack_public_path__ + "img/virgin-chilled.1388f320.png";